// extracted by mini-css-extract-plugin
export default {"hcaptcha":"styles_hcaptcha_uFf47","inputSection":"styles_input-section_X6JIv","inputContainer":"styles_input-container_sL217","error":"styles_error_JhhV6"};